import { TRoleOption } from "src/components/Organizations/Organization/MemberRolePicker"
import { THomeGroupRole } from "src/data/homeGroups/types/homeGroupTypes"
import { THomeRole } from "src/data/homes/types/homeTypes"
import { TOrganizationRole } from "src/data/organizations/types/organizationMemberTypes"
import { langKeys } from "src/i18n/langKeys"

export type TMemberAccess =
  | "org-level-access"
  | "building-level-access"
  | "area-level-access"
  | "home-level-access"

export type TOrgRoleOptions = TRoleOption<TOrganizationRole>
export type THomeGroupRoleOptions = TRoleOption<THomeGroupRole>
export type THomeRoleOptions = TRoleOption<THomeRole>

export const orgRoleOptions = [
  {
    label: langKeys.organizations_admin_role_title,
    description:
      langKeys.organizations_organization_admin_role_short_description,
    role: "admin",
  },
  {
    label: langKeys.organizations_member_role_title,
    description:
      langKeys.organizations_organization_member_role_short_description,
    role: "member",
  },
  {
    label: langKeys.organizations_responder_role_title,
    description:
      langKeys.organizations_organization_responder_role_short_description,
    role: "responder",
  },
  {
    label: langKeys.organizations_role_team_operator,
    description: langKeys.member_role_operator_short_description,
    role: "operator",
  },
  {
    label: langKeys.organizations_role_minimum,
    description: langKeys.organizations_role_minimum_short_description,
    role: "minimum",
  },
  {
    label: langKeys.owner,
    description: ``,
    role: "owner",
    hidden: true,
  },
] as const satisfies TOrgRoleOptions[]

export const homeGroupRoleOptions = [
  {
    label: langKeys.organizations_homegroup_admin_role_title,
    description: langKeys.organizations_homegroup_admin_role_short_description,
    role: "admin",
  },
  {
    label: langKeys.organizations_homegroup_member_role_title,
    description: langKeys.organizations_homegroup_member_role_short_description,
    role: "member",
  },
  {
    label: langKeys.organizations_homegroup_responder_role_title,
    description:
      langKeys.organizations_homegroup_responder_role_short_description,
    role: "responder",
  },
  {
    label: langKeys.organizations_homegroup_operator_role_title,
    description: langKeys.member_role_operator_short_description,
    role: "operator",
  },
] as const satisfies THomeGroupRoleOptions[]

export const homeRoleOptions = [
  {
    label: langKeys.organizations_role_home_admin,
    description: langKeys.organizations_home_admin_role_short_description,
    role: "admin",
  },
  {
    label: langKeys.organizations_role_home_member,
    description: langKeys.organizations_home_member_role_short_description,
    role: "member",
  },
  {
    label: langKeys.organizations_role_home_responder,
    description: langKeys.organizations_home_responder_role_short_description,
    role: "responder",
  },
  {
    label: langKeys.organizations_role_home_operator,
    description: langKeys.member_role_operator_short_description,
    role: "operator",
  },
] as const satisfies THomeRoleOptions[]
